// Motion panels (.motion-panel): Lottie animations named by `data-motionname`.
//
// The player is about 290 KB, so it is fetched only when a page has a panel,
// and never mounted into a page that was left before it arrived. Every
// animation a page starts is destroyed when the page goes, which stops its
// frame loop and releases its SVG.

export function mountMotionPanels({ root }) {
  const panels = [...root.querySelectorAll(".motion-panel")];
  if (!panels.length) return;

  let live = true;
  let animations = [];
  import("../libs/lottie.js").then((module) => {
    if (!live) return;
    const lottie = module.default || module;
    animations = panels.map((panel) =>
      lottie.loadAnimation({
        container: panel,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: panel.dataset.motionname,
      }),
    );
  });

  return () => {
    live = false;
    animations.forEach((animation) => animation.destroy());
    animations = [];
  };
}
